<template>
    <div class="searchContainer">
        <!-- 搜索框 -->
        <div class="goSearch">
            <div>
                <form action="javascript:void 0">
                    <input type="text" placeholder="请输入" v-model="searchVal" @keyup.13="addHistorySearch()">
                </form>
                <img src="../assets/imgs/search/clear.png" alt="" @click="searchVal='';">
            </div>
            <div v-show="!isBtn" @click="back">取消</div>
            <div v-show="isBtn" @click="addHistorySearch()">搜索</div>
        </div>
        <div class="labelList" v-show="!isSearch">
            <div class="searchHistory" v-if="searchHistory.length">
                <div>
                    <p>历史搜索</p>
                    <img src="" alt="" @click="delHistorySearch">
                </div>
                <ul>
                    <li v-for="item in searchHistory" :key="item" @click="addHistorySearch(item)">{{item}}</li>
                </ul>
            </div>
            <!-- <div class="hostSearch">
                <div>
                    <p>热门搜索</p>
                </div>
                <ul>
                    <li @click="addHistorySearch('伟成演说')">伟成演说</li>
                </ul>
            </div> -->
        </div>
        <div  class="searchBookList" v-show="isSearch" ref="boxH" @scroll.passive="onScroll">
            <ul ref="scrollH">
                <li v-for="(item, index) in searchBookList" :key="index" @click="goBookInfo(item.bookId)">
                <img :src="item.cover" alt>
                <div>
                    <div>
                        <p class="bookName">{{item.bookName}}</p>
                        <p class="bookDescribe">{{ item.summary | valLength(44) }}</p>
                        </div>
                        <div>
                        <div>
                            <p class="authorName">{{ item.authorName | valLength(8) }}</p>
                            <p>{{item.readSum | playNum}}</p>
                        </div>
                        <div></div>
                    </div>
                </div>
                </li>
            </ul>
            <ul v-if="!searchBookList.length">
                <li style="text-align: center;color: #999;font-size: 14px;display: block;padding: 30px 0;">——————&nbsp;空空如也&nbsp;——————</li>
            </ul>
        </div>
        <!-- <router-view :search-val="val" ></router-view> -->
    </div>
</template>
<script>
import Bus from "../assets/js/eventBus.js";
export default {
    // name: "搜索"
    data() {
        return {
            isBtn: false,
            searchVal: "",
            isSearch: false,
            searchHistory: [],
            pageNum: 1,
            pages: 1,
            searchBookList: [],
            isMoreList: true,
            scrollH: 0,
        }
    },
    beforeRouteEnter(to, from, next) {
        let that = this;
        if(from.name  == 'bookInfo'){

            to.meta.isBack = true;

        }
        next();
    },
    created() {
        var that = this;
        // Bus.$on("searchName", (val)=>{
        //     that.searchVal = val;
        //     if( val ) that.isBtn = true;
        //     that.addHistorySearch();
        // })
        if( localStorage.getItem(localStorage.getItem("officeId") + localStorage.getItem("classTypeId") + "searchHistory") ) {
            that.searchHistory = JSON.parse(localStorage.getItem(localStorage.getItem("officeId") + localStorage.getItem("classTypeId") + "searchHistory"));
        }
    },
    activated() {
        let that = this;
        if(!that.$route.meta.isBack) {
            that.isBtn = false;
            that.isSearch = false;
            that.searchVal = "";
            that.pageNum = 1;
        }else{
            that.$route.meta.isBack=false;
        }
        
    },
    methods: {
        addHistorySearch(val) {
            var that = this;
            that.searchVal = (val ? val : that.searchVal);

            // 添加搜索历史 最大5个
            var searchHistory = [];
            var isPush = true;
            if( localStorage.getItem(localStorage.getItem("officeId") + localStorage.getItem("classTypeId") + "searchHistory") ) {
                searchHistory = JSON.parse(localStorage.getItem(localStorage.getItem("officeId") + localStorage.getItem("classTypeId") + "searchHistory"));
                for( var i=0,len=searchHistory.length; i<len; i++ ){
                    if( searchHistory[i] == that.searchVal ){
                        isPush = false;
                        break;
                    }
                }
                if( isPush ) {
                    if( searchHistory.length < 5 ) {
                        searchHistory.unshift(that.searchVal);
                    }else{
                        searchHistory.pop();
                        searchHistory.unshift(that.searchVal);
                    }
                }
            }else{
                searchHistory.push(that.searchVal);
            }
            localStorage.setItem(localStorage.getItem("officeId") + localStorage.getItem("classTypeId") + "searchHistory", JSON.stringify(searchHistory));
            that.searchHistory = JSON.parse(localStorage.getItem(localStorage.getItem("officeId") + localStorage.getItem("classTypeId") + "searchHistory"));

            
            that.pageNum = 1;
            that.$refs.boxH.scrollTop = 0;
            that.getSearchList();
            
        },
        getSearchList(){
            var that = this;
            that.isSearch = true;
            // 获取搜索列表
            var data = {
                page: {
                    pageSize: 20,
                    pageNum: that.pageNum
                },
                ticket: localStorage.getItem("ticket"),
                search: that.searchVal
            }
            that.allApi.searchList(data).then((resource) => {
                // console.log(resource.data);
                
                if( that.pageNum == 1 ){
                    that.pages = resource.data.data.totalPage;
                    that.searchBookList = resource.data.data.list;
                }else{
                    that.searchBookList = that.searchBookList.concat(resource.data.data.list);
                }
                
                that.$nextTick(()=>{
                    // console.log(that.$refs.scrollH.offsetHeight)
                    that.scrollH = that.$refs.scrollH.offsetHeight;
                    that.isMoreList = true;
                })
            })
        },
        onScroll() {
            var that = this;
            var boxH = that.$refs.boxH.offsetHeight;
            var boxTop = that.$refs.boxH.scrollTop;
            if (that.isMoreList && that.scrollH - boxH - boxTop < 30) {
                if( that.pageNum + 1 > that.pages ){
                    that.pageNum = that.pages;
                    return false;
                }else{
                    that.isMoreList = false;
                    that.pageNum ++;
                    that.getSearchList();
                }
            }
        },
        goBookInfo(id){
            var that = this;
            that.$router.push({
                path: `bookInfo/${id}`
            })
        },
        delHistorySearch() {
            var that = this;
            localStorage.removeItem(localStorage.getItem("officeId") + localStorage.getItem("classTypeId") + "searchHistory");
            that.searchHistory = [];
        },
        back(){
            var that = this;
            that.$router.go(-1);
        },
    },
    watch: {
        searchVal(newV) {
            var that = this;
            // if( that.commin.fn.trim(newV) == "" ) {
            //     that.isBtn = false;
            //     that.$router.push({
            //         path: "/search/heatSearch"
            //     })
            // }else{
            //     that.isBtn = true;
            //     that.$router.push({
            //         path: "/search/searchList"
            //     })
            // }
            if( newV == "" || !newV ){
                that.isBtn = false;
                that.isSearch = false;
            }else{
                that.isBtn = true;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.searchContainer{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    top: 0;
    z-index: 2;
    background: #fff;
    // overflow-y: scroll;
    // -webkit-overflow-scrolling: touch;
    .goSearch{
        padding: rem(22px) rem(40px) rem(60px);
        overflow: hidden;
        width: 100%;
        // height: rem(148px);
        background: #fff;
        
        >div:first-child{
            float: left;
            position: relative;
            >form{
                >input{
                    width: rem(580px);
                    height: rem(60px);
                    line-height: rem(60px);
                    padding: 0 rem(60px);
                    color: #666;
                    // text-indent: rem(40px);
                    background: url('../assets/imgs/index/search.png') rem(20px) center / rem(30px) rem(30px) no-repeat, #EAE9E9;
                    border: 0;
                    border-radius: rem(30px);
                    outline: none;
                    font-size: rem(24px);
                }
            }
            >img{
                position: absolute;
                right: rem(20px);
                top: 0;
                bottom: 0;
                margin: auto;
                width: rem(30px);
                height: rem(30px);
            }
        }
        >div:nth-child(2){
            float: left;
            font-size: rem(32px);
            color: #111;
            line-height: rem(60px);
            margin-left: rem(13px);
            // &:last-child{
            //     color: #65ADEF;
            //     // background: #fff;
            //     // border: 1px solid #e75652;
            // }
        }
        >div:last-child{
            float: left;
            font-size: rem(32px);
            color: #65ADEF;
            line-height: rem(60px);
            margin-left: rem(13px);
        }
    }
    >.labelList{
        position: absolute;
        left: 0;
        top: rem(142px);
        right: 0;
        bottom: 0;
        .searchHistory,
        .hostSearch{
            margin-bottom: rem(90px);
            padding: 0 rem(40px);
            >div{
                background: url("../assets/imgs/search/historySearch.png") center left / rem(30px) rem(30px) no-repeat;
                padding-left: rem(45px);
                line-height: rem(45px);
                font-size: rem(32px);
                overflow: hidden;
                margin-bottom: rem(30px);
                p{
                    float: left;
                }
                img{
                    float: right;
                    width: rem(30px);
                    height: rem(34px);
                    margin-top: rem(5px);
                    background: url("../assets/imgs/search/historySearchDel.png") center left / rem(30px) rem(30px) no-repeat;
                }
            }
            ul{
                overflow: hidden;
                li{
                    float: left;
                    padding: rem(10px) rem(27px);
                    font-size: rem(28px);
                    color: #333;
                    background: #EFEFF3;
                    border-radius: rem(30px);
                    margin-right: rem(27px);
                    margin-bottom: rem(30px);
                }
            }
        }
        .hostSearch{
            >div{
                background: url("../assets/imgs/search/hostSearch.png") center left / rem(30px) rem(30px) no-repeat;
            }
        }
    }
    >.searchBookList{
        position: absolute;
        left: 0;
        top: rem(142px);
        right: 0;
        bottom: 0;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        padding: 0 rem(40px);
        >ul{
            overflow: hidden;
            > li {
                width: 100%;
                padding-bottom: rem(30px);
                margin-bottom: rem(30px);
                border-bottom: 1px solid #e5e5e5;
                overflow: hidden;
                display: flex;
                > img {
                    width: rem(200px);
                    height: rem(200px);
                    margin-right: rem(40px);
                    border-radius: rem(6px);
                }
                > div {
                    width: 0%;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                > div:first-child {
                    .bookName {
                        font-size: rem(32px);
                        font-weight: bold;
                        color: #111;
                        line-height: rem(45px);
                        margin-bottom: rem(10px);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .bookDescribe {
                        font-size: rem(24px);
                        color: #999;
                        line-height: rem(32px);
                    }
                }

                > div:last-child {
                    overflow: hidden;
                    font-size: rem(24px);
                    color: #333;
                    line-height: rem(34px);
                    >div:first-child{
                        float: left;
                        overflow: hidden;
                        > p {
                            float: left;
                            position: relative;
                            padding-left: rem(30px);
                            &:first-child {
                                margin-right: rem(42px);
                                &::before {
                                    content: "";
                                    background: url('../assets/imgs/index/anchorIcon.png') center / rem(25px) rem(25px) no-repeat;
                                    width: rem(25px);
                                    height: rem(25px);
                                    position: absolute;
                                    left: 0;
                                    top: rem(4px);
                                }
                            }
                            &:last-child {
                                &::before {
                                    content: "";
                                    background: url('../assets/imgs/index/playNumIcon.png') center / rem(25px) rem(25px) no-repeat;
                                    width: rem(25px);
                                    height: rem(25px);
                                    position: absolute;
                                    left: 0;
                                    top: rem(4px);
                                }
                            }
                        }
                    }
                    >div:last-child{
                        float: right;
                    }
                }
                }
            }
            }
    }
}
</style>
